/* ============================================
   Cart cross-sell — adds a recommended 1-pack
   alongside whatever's already in the cart.
   No remove, no swap, no probe. Just an add.
   ============================================ */

class CartCrossSell extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-cart-cross-sell-add]');
    this.recommendedVariantId = this.dataset.recommendedVariantId;
    if (this.button) {
      this.button.addEventListener('click', this.add.bind(this));
    }
  }

  getCartParent() {
    return (
      this.closest('cart-items') ||
      this.closest('cart-drawer-items') ||
      document.querySelector('cart-items') ||
      document.querySelector('cart-drawer-items')
    );
  }

  resetButton() {
    if (this.button) {
      this.button.disabled = false;
      this.button.classList.remove('is-loading');
      if (this._originalButtonText) {
        this.button.textContent = this._originalButtonText;
      }
    }
  }

  async add() {
    if (this._addInFlight) return;
    this._addInFlight = true;
    const cartParent = this.getCartParent();
    if (!cartParent || !this.recommendedVariantId) {
      this._addInFlight = false;
      return;
    }

    this.button.disabled = true;
    this.button.classList.add('is-loading');
    this._originalButtonText = this.button.textContent;
    this.button.textContent = 'Adding...';

    const timeoutMs = 8000;
    const controller = new AbortController();
    const timer = setTimeout(() => {
      controller.abort();
      this.resetButton();
    }, timeoutMs);

    try {
      const isDrawer = !!this.closest('cart-drawer-items');
      const sections = isDrawer
        ? null
        : cartParent.getSectionsToRender().map((s) => s.section);
      const addBody = {
        items: [{
          id: parseInt(this.recommendedVariantId, 10),
          quantity: 1,
        }],
      };
      if (sections) {
        addBody.sections = sections;
        addBody.sections_url = window.location.pathname;
      }
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        signal: controller.signal,
        body: JSON.stringify(addBody),
      });
      const state = await addRes.json();
      clearTimeout(timer);
      if (state && state.sections) {
        cartParent.getSectionsToRender().forEach((section) => {
          const target = document.getElementById(section.id);
          if (!target) return;
          const inner = target.querySelector(section.selector) || target;
          const sourceHtml = state.sections[section.section];
          if (!sourceHtml) return;
          const parsed = new DOMParser().parseFromString(sourceHtml, 'text/html');
          const sourceInner = parsed.querySelector(section.selector) || parsed.body;
          inner.innerHTML = sourceInner.innerHTML;
        });
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-cross-sell',
          cartData: state,
          variantId: this.recommendedVariantId,
        });
      }
    } catch (e) {
      console.error('[cart-cross-sell] add failed', e);
      clearTimeout(timer);
      this.resetButton();
    } finally {
      this._addInFlight = false;
    }
  }
}

if (!customElements.get('cart-cross-sell')) {
  customElements.define('cart-cross-sell', CartCrossSell);
}
